import { Controller } from "@hotwired/stimulus"

const MESSAGES = [
  "Pharos is thinking...",
  "Analyzing your data schema...",
  "Finding the right tables and fields...",
  "Crafting your visualization...",
  "Almost there, putting it together...",
  "Hang tight, this won't take long...",
]

export default class extends Controller {
  static targets = ["text"]

  connect() {
    this.index = 0
    this.interval = setInterval(() => this.cycle(), 3000)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  cycle() {
    this.index = (this.index + 1) % MESSAGES.length
    this.textTarget.textContent = MESSAGES[this.index]
  }
}
